import DemissaoForm from './DemissaoForm';
import FuncionarioForm from './FuncionarioForm';
import SituacaoForm from './SituacaoForm';

export default { DemissaoForm, FuncionarioForm, SituacaoForm };
